<!-- <div class="wrapper" *ngIf="isAuthenticated; else noAuth"> -->
<div>
    <app-header></app-header>
</div>
<div class="wrapper">
    <div class="sidebar" data-color="squirrel" data-background-color="white">
        <squirrel-side-nav></squirrel-side-nav>
        <div class="sidebar-background"></div>
    </div>
    <div class="main-panel">
        <!-- <squirrel-top-nav></squirrel-top-nav> -->
        <router-outlet></router-outlet>
        <div *ngIf="isMaps('maps')">
            <!-- <squirrel-footer></squirrel-footer> -->
        </div>
    </div>

</div>


<!-- <ng-template #noAuth>
    <button (click)="login()">Click Me To Login</button>
</ng-template> -->